import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing
}) => ({
  iconButton: {
    position: 'absolute',
    right: spacing(5.5),
    top: '50%',
    marginTop: spacing(-2)
  },
  icon: {
    width: spacing(2.5),
    height: spacing(2.5)
  }
}));
